// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 950 ? "4ae8876b" : chunkId) + "." + {"604":"5306a4dfe6a747b8","950":"aae8becf5adc0380"}[chunkId] + ".js";
};